// `ng build --stage` replaces `environment.ts` with `environment.stage.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  apiUrl: 'https://analytics.epathos.stageweb.builders/api/',
};
